module.exports = __webpack_public_path__ + "static/media/camara.8050ce20.jpg";